module.exports = __webpack_public_path__ + "047c65f687bd4f04b0dca6e6eae2ebe8.png";